/**
 * Auto-Publish Store
 *
 * Simplified store that only tracks the user's auto-publish preference.
 * Backend now handles all job tracking via publish_status field on content.
 *
 * Previous implementation tracked jobs in localStorage - this has been removed
 * because the backend now tracks publish state (pending -> publishing -> published/failed).
 */
import { create } from "zustand";
import { persist } from "zustand/middleware";

interface AutoPublishStore {
	/** Whether auto-publish is enabled for new content creation */
	enabled: boolean;

	/** Toggle auto-publish on/off */
	setEnabled: (enabled: boolean) => void;
}

export const useAutoPublishStore = create<AutoPublishStore>()(
	persist(
		(set) => ({
			enabled: true,

			setEnabled: (enabled) => set({ enabled }),
		}),
		{
			name: "auto-publish-storage",
		},
	),
);

export default useAutoPublishStore;
